export default __webpack_public_path__ + "static/media/404.d03b2015.png";